<div class="smart-cover-{{ mode }}" [ngClass]="{'search-page': isSearchPage}">
  <div *ngIf="item && item.isNew" class="label-new">New</div>
  <div [ngClass]="{'loading-background': loadingCard}" class="cover" matRipple mwoRippleHover>
    <!--    <div class="cover-effect" [ngStyle]="{-->
    <!--                'background': 'linear-gradient(60deg, ' + backgroundColor +' 50%, transparent 50%)'-->
    <!--                }">-->
    <!--    </div>-->
    <!--    <div class="darken"></div>-->
    <!--    <h3>{{ coverTitle | translate }}</h3>-->
    <mat-spinner *ngIf="loadingCard" class="spinner-card"></mat-spinner>
    <img #img (error)="img.src='assets/icons/default_icon.webp'" *ngIf="!loadingCard && (item.libraryTopicType === 'EVENTFAMILY' || item.events)" [ngClass]="{'eventfamily': item.libraryTopicType === 'EVENTFAMILY' || item.events }"
         [src]="coverSrc || mock"
         alt="{{ coverTitle | translate }} cover" class="cover-img"
         cover loading="lazy"/>
    <img #img (error)="img.src='assets/icons/default_icon.webp'" *ngIf="!loadingCard && (item.libraryTopicType !== 'EVENTFAMILY' && !item.events)" [ngClass]="{'no-pattern': applyPattern(coverSrc)}"
         [src]="coverSrc" alt="{{ coverTitle | translate }} cover"
         class="cover-img" cover loading="lazy"/>
    <ng-content select="[playBtn]"></ng-content>
  </div>
</div>
